// src/components/Header/index.jsx
import React from 'react';
import { Layout, Menu, Button, Space, Avatar, Dropdown } from 'antd';
import { 
  HomeOutlined, 
  EditOutlined, 
  UserOutlined,
  FolderOutlined,
  LoginOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './index.css';

const { Header: AntHeader } = Layout;

const AppHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  
  // 从localStorage获取用户信息
  const username = localStorage.getItem('username') || '用户';
  const avatar = localStorage.getItem('avatar') || null;

  // 导航菜单项
  const menuItems = [
    {
      key: '/home',
      icon: <HomeOutlined />,
      label: <Link to="/home">首页</Link>,
    },
    {
      key: '/archive',
      icon: <FolderOutlined />,
      label: <Link to="/archive">归档</Link>,
    },
    {
      key: '/about',
      icon: <UserOutlined />,
      label: <Link to="/about">关于</Link>, // 🔴 点击会跳转到404页面
    },
  ];

  const handleLogout = () => {
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.removeItem('username');
    localStorage.removeItem('avatar');
    navigate('/auth');
  };

  // 用户下拉菜单
  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '我的信息',
      onClick: () => navigate('/profile') // ✅ 点击头像跳转到个人资料页面
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  return (
    <AntHeader className="app-header">
      <div className="header-container">
        <div className="logo">
          <Link to="/" style={{ fontSize: '20px', fontWeight: 'bold', color: '#417be0' }}>
            my-blog-app
          </Link>
        </div>

        <div className="nav-container">
          <Menu
            theme="light"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            className="nav-menu"
          />
          
          <Space className="action-buttons">
            {isLoggedIn ? (
              <>
                <Button 
                  type="primary" 
                  icon={<EditOutlined />}
                  onClick={() => navigate('/write')}
                  size="small"
                  style={{ marginTop: '-2px' }}
                >
                  写文章
                </Button>
                
                {/* 用户头像和名字 */}
                <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                  <div className="user-info" style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    cursor: 'pointer',
                    padding: '4px 8px',
                    borderRadius: '20px',
                    transition: 'background 0.3s',
                    marginLeft: '8px'
                  }}>
                    <Avatar 
                      size="small"
                      src={avatar}
                      icon={<UserOutlined />}
                      style={{ backgroundColor: avatar ? 'transparent' : '#1890ff' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: 500 }}>{username}</span>
                  </div>
                </Dropdown>
              </>
            ) : (
              <Button 
                type="primary"
                icon={<LoginOutlined />}
                onClick={() => navigate('/auth')}
                size="small"
                style={{ marginTop: '-2px' }}
              >
                登录
              </Button>
            )}
          </Space>
        </div>
      </div>
    </AntHeader>
  );
};

export default AppHeader;